<template>
  <client-only>
    <GenericAccordion
      v-if="!loading && articles.length"
      :headline="$t('productPage.info.guidesAndInspiration')"
    >
      <!-- content -->

      <div class="grid grid-cols-2 gap-12 pb-24">
        <nuxt-link
          v-for="article in articles"
          :key="article.uuid"
          :to="`/${article.full_slug}`"
          class="group"
        >
          <div class="relative overflow-hidden">
            <nuxt-img
              :src="article.content.summaryImage.filename"
              preset="standard"
              loading="lazy"
              sizes="mob375:50vw mob390:50vw mob414:50vw desk:273px"
              class="w-full object-cover aspect-wide group-hover:scale-110 transition-transform duration-300"
              :alt="article.content.summaryImage.alt || ''"
            />
          </div>
          <div class="pr-12 pt-16">
            <div
              v-if="article.content.summaryCategories"
              class="type-tagline-xs mb-8"
            >
              <span
                v-for="(keyword, ki) in article.content.summaryCategories"
                :key="ki"
                class="inline-block mr-16"
              >
                {{ getKeywordTranslation(keyword) }}
              </span>
            </div>
            <div class="type-headline-md">
              {{ article.content.summaryTitle }}
            </div>
          </div>
        </nuxt-link>
      </div>
    </GenericAccordion>
  </client-only>
</template>

<script lang="ts" setup>
import { ProductModel } from '#models/product';
import { useGlobalContentStore } from '~/store/globalContent';
import { StoryBlokArticlePage } from '#constants/types/storyblok';
const storyblokApi = useStoryblokApi();
const globalContent = useGlobalContentStore();
const { $t } = useNuxtApp();

const props = defineProps<{
  productItem: ProductModel;
}>();

const loading = ref(true);

onMounted(()=> {
  setTimeout(() => loadArticles(), 50);
});

const articles = ref<StoryBlokArticlePage[]>([]);

const loadArticles = async() => {
  const filters = props.productItem.categories.map((m) => {
    return { 'category.category.id': { in: m.code } };
  }) as any[];

  /*if (props.productItem.brand?.code) {
    filters.push({ 'brand.brand.id': { in: props.productItem.brand.code } });
  }*/

  const { data } = await storyblokApi.get('cdn/stories/', {
    version: useRuntimeConfig().public.storyblokStoriesVersion as 'draft' | 'published',
    starts_with: globalContent.articlesFolder,
    content_type: 'ArticlePage',
    excluding_fields: 'body',
    per_page: 2,
    filter_query: {
      __or: filters,
    },
  });
  if (data) {
    articles.value = data.stories;
    loading.value = false;
  } else {
    loading.value = false;
  }
};

const getKeywordTranslation = (keyword: string) => {
  return $t(`articles.keyword.${keyword}`);
};

</script>
